import { fileSave } from "browser-fs-access";

import { Schematic } from "../Schematic";
import { useSchematicBuilderContext } from "../SchematicBuilderContext";

export function SaveSchematic() {
  const { name, getRootSchematic, latestSchematicFileHandle } =
    useSchematicBuilderContext();

  return (
    <button
      className="builder-icon-button builder-action builder-save-schematic"
      type="button"
      onClick={async () => {
        const schematic: Schematic = getRootSchematic();
        latestSchematicFileHandle.current = await fileSave(
          new Blob([JSON.stringify(schematic, null, 2)]),
          {
            fileName: `${schematic.name}-schematic.json`,
            extensions: [".json"],
            mimeTypes: ["application/json"],
            description: "Form schematic",
            id: name,
          },
          latestSchematicFileHandle.current,
        );
      }}
      title="Save schematic"
    >
      💾
    </button>
  );
}
